import { render } from "./AdvicesConfigModal.vue?vue&type=template&id=4193e8f7&ts=true"
import script from "./AdvicesConfigModal.vue?vue&type=script&lang=ts"
export * from "./AdvicesConfigModal.vue?vue&type=script&lang=ts"

import "./AdvicesConfigModal.vue?vue&type=style&index=0&id=4193e8f7&lang=css"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__